import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/not-found.tsx");
